export const TWITTER_LOGIN_START = "TWITTER_LOGIN_START";
export const TWITTER_LOGIN_SUCCESS = "TWITTER_LOGIN_SUCCESS";
export const TWITTER_LOGIN_FAIL = "TWITTER_LOGIN_FAIL";
export const FACEBOOK_LOGIN_START = "FACEBOOK_LOGIN_START";
export const FACEBOOK_LOGIN_SUCCESS = "FACEBOOK_LOGIN_SUCCESS";
export const FACEBOOK_LOGIN_FAIL = "FACEBOOK_LOGIN_FAIL";
export const TWITTER_SIGN_OUT_START = "TWITTER_SIGN_OUT_START";
export const TWITTER_SIGN_OUT_SUCCESS = "TWITTER_SIGN_OUT_SUCCESS";
export const TWITTER_SIGN_OUT_FAIL = "TWITTER_SIGN_OUT_FAIL";
export const DESO_LOGIN_SUCCESS = "DESO_LOGIN_SUCCESS";
export const SET_MODAL_VISIBLE = "SET_MODAL_VISIBLE";
export const SET_CHECK = "SET_CHECK";
export const SET_SHOW_IFRAME = "SET_SHOW_IFRAME";
export const HANDLE_APPROVE = "HANDLE_APPROVE";
export const REAL_TIME_SYNC_DATA = "REAL_TIME_SYNC_DATA";
export const REAL_TIME_MODAL = "REAL_TIME_MODAL";
export const REAL_TIME_LOADING = "REAL_TIME_LOADING";
export const T_USER_NAME = "TWITTER_USER_NAME";
export const CART = "CART";
export const SET_COLOR_SHOW = "SET_COLOR_SHOW";
export const SELECT_ALL_POST = "SELECT_ALL_POST";
export const SET_IS_DESO_BALANCE_MODAL = "SET_IS_DESO_BALANCE_MODAL";
export const FETCH_TWITTER_TIMELINE_START = "FETCH_TWITTER_TIMELINE_START";
export const FETCH_TWITTER_TIMELINE_SUCCESS = "FETCH_TWITTER_TIMELINE_SUCCESS";
export const FETCH_TWITTER_TIMELINE_FAIL = "FETCH_TWITTER_TIMELINE_FAIL";
export const POST_DATA_START = "POST_DATA_START";
export const POST_DATA_SUCCESS = "POST_DATA_SUCCESS";
export const POST_DATA_FAIL = "POST_DATA_FAIL";
export const POST_DATA_PARTIAL_SUCCESS = "POST_DATA_PARTIAL_SUCCESS";
export const SET_USER_META_DATA = "SET_USER_META_DATA";
export const UPDATE_USER_PROFILE_DATA = "UPDATE_USER_PROFILE_DATA";
export const FOLLOW_FORM_DATA = "FOLLOW_FORM_DATA";
export const UPDATE_PROFILE_STATE = "UPDATE_PROFILE_STATE";
export const DESO_USER_PROFILE_DATA = "DESO_USER_PROFILE_DATA";
export const WORDPRESS_LOGIN_START = "WORDPRESS_LOGIN_START";
export const WORDPREES_LOGIN_SUCCESS = "WORDPREES_LOGIN_SUCCESS";
export const WORDPRESS_LOGIN_FAIL = "WORDPRESS_LOGIN_FAIL";
